<ng-container *ngIf="(notifications$ | async).length">
  <div class="data-set-name-container">
    <ng-container [ngSwitch]="opened">
      <mat-icon class="cursor mat-icon material-icons-outlined color-grey-light color-black-hover" *ngSwitchCase="true" (click)="onToggle()">expand_less</mat-icon>
      <mat-icon class="cursor mat-icon material-icons-outlined color-grey-light color-black-hover" *ngSwitchCase="false" (click)="onToggle()">expand_more</mat-icon>
    </ng-container>
    <span [matBadge]="(notifications$ | async).length">{{ site.attributes.name }}</span>
  </div>
  <div class="notifications-container" *ngIf="opened">
    <app-notification [notification]="notification" *ngFor="let notification of notifications$ | async"></app-notification>
  </div>
</ng-container>
